import React from "react";
import PropTypes from "prop-types";
import Lightbox from "../Lightbox";
import Images from "./Images";

import styles from "./gallery.module.scss";

class Gallery extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        source: PropTypes.string,
        captionContent: PropTypes.object
      })
    )
  };
  state = {
    modalIsOpen: false,
    currentIndex: 0
  };
  closeModal = (event) => {
    if (window.$(event.target).closest(`.lightbox-view`).length) {
      return;
    }
    this.setState({
      modalIsOpen: false,
      currentIndex: 0
    });
  };
  openModal = (index) => () => {
    this.setState({
      modalIsOpen: true,
      currentIndex: index
    });
  };
  render() {
    const {modalIsOpen, currentIndex} = this.state;
    const {items} = this.props;
    return (
      <div className={styles.root}>
        <Images items={items} onClick={this.openModal} />
        <Lightbox
          items={items}
          isOpen={modalIsOpen}
          currentIndex={currentIndex}
          captionRender={(view) => (
            <div>
              <h3 className={styles.title}>{view.captionContent.title}</h3>
              <p className={styles.description}>
                {view.captionContent.description}
              </p>
            </div>
          )}
          onClose={this.closeModal}
        />
      </div>
    );
  }
}

export default Gallery;
